import React from "react";
import UIComponent from "components/UiComponent";
import MsgBox from "sis_ui/modules/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faSave } from "@fortawesome/free-solid-svg-icons/faSave";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { faLockOpen } from "@fortawesome/free-solid-svg-icons/faLockOpen";
import evaluationsConfig from "../../../moduleConfig";
import config from "root/../config";
import { useTranslation } from "react-i18next";
import { withRouter } from "components/Routing";

export const getIconAndColor = (action_code) => {
  let result = {};
  switch (action_code) {
    case "SAVE":
      result = { icon: faSave, color: "color-blue" };
      break;
    case "SUBMIT":
      result = { icon: faCheck, color: "color-green" };
      break;
    case "DELETE":
      result = { icon: faTrash, color: "color-red-light" };
      break;
    case "SEND_BACK_TO_COURSE_DIRECTOR":
      result = { icon: faArrowLeft, color: "color-green" };
      break;
    case "SEND_TO_LEARNER":
      result = { icon: faArrowRight, color: "color-green" };
      break;
    case "SEND_BACK_TO_SUPERVISOR":
      result = { icon: faArrowLeft, color: "color-green" };
      break;
    case "SUBMIT_TO_COURSE_DIRECTOR":
      result = { icon: faArrowRight, color: "color-green" };
      break;
    case "POST_TO_TRANSCRIPT":
      result = { icon: faCheck, color: "color-green" };
      break;
    case "OVERWRITE":
      result = { icon: faSave, color: "color-blue" };
      break;
    case "UNLOCK":
      result = { icon: faLockOpen, color: "color-green" };
      break;    
    default:
      result = { icon: faCheck, color: "color-green" };
      break;
  }

  return result;
};

const EvaluationButtons = ({
  formDetails,
  compact,
  getUserForm,
  onClickHandler,
  router,
}) => {
  const { navigate} = router;
  let setButtonsState = () => {};
  const { t } = useTranslation();  
  let actionList = "," + formDetails.ACTION_LIST + ",";
  const {WORKFLOW:workflowData, redirectToOtherForm, redirectFormName, redirectUserFormId} = formDetails;
  let submitBodyTemplate = t(
    "lbl.ARE_YOU_SURE_SUBMIT_EVAL",
    "Are you sure you want to submit your evaluation?"
  );
  let submitOnBehalfBodyTemplate = t(
    "lbl.ASSESMENT_SUBMITED_BY_EVALUATOR",
    "This assessment is being submitted by, or on behalf of the evaluator."
  );
  let submitYesLabel = t("lbl.YES", "Yes");
  let submitNoLabel = t("lbl.NO", "No");
  
  if(redirectToOtherForm) {
    submitBodyTemplate = t("lbl.SUBMIT_EVAL_GO_TO_LINKED_EVAL_CONFIRMATION",{LINKED_EVALUATION_FORM_NAME:redirectFormName});
    submitOnBehalfBodyTemplate = `${submitOnBehalfBodyTemplate} <br><br> \n${submitBodyTemplate}`;
    submitYesLabel = t("lbl.OK", "OK");
    submitNoLabel = t("lbl.CANCEL", "Cancel");
  }  

  const _deleteEvaluationFormCallback = (result) => {
    if (result.body) {
      MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
      if (result.body.STATUS == "success") {
        window.localStorage.setItem("evaluations-list-igonre-cache", true);
        navigate("/" + evaluationsConfig.map.EVALUATIONS_LIST.path);
      }
    } else {
      MsgBox.drawMessage(
        "error",
        t(
          "lbl.ERROR_PROCESSING_REQUEST",
          "There was an error processing your request"
        )
      );
    }
    setButtonsState("active");
  };
  const _saveEvaluationFormCallBack = (result) => {
    if (result) {
      getUserForm();
      MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
      window.localStorage.setItem("evaluations-list-igonre-cache", true);
    } else {
      MsgBox.drawMessage(
        "error",
        t(
          "lbl.ERROR_PROCESSING_REQUEST",
          "There was an error processing your request"
        )
      );
    }

    setButtonsState("active");
  };

  const _submitEvaluationFormCallback = ({setError , actionCode=''}) => {
    return (result) => {
      if (result.body) {
        if (result.body.STATUS == "success") {
          window.localStorage.setItem("evaluations-list-igonre-cache", true);
          MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);            
          if(redirectToOtherForm) {
            navigate("/" + evaluationsConfig.map.EVALUATION_FORM.path + "/" + redirectUserFormId);
          } else {                         
            if(actionCode != 'SAVE') {
              navigate("/" + evaluationsConfig.map.EVALUATIONS_LIST.path);
            }         
          }
          getUserForm();
        }

        if (result.body.STATUS == "error") {
          result.body.MESSAGE.forEach((item, i) => {
            if (item.TAG == "") {
              MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
            } else {
              setError(item.TAG, item.MESSAGE);
            }
          });
        }
      } else {
        MsgBox.drawMessage(
          "error",
          t(
            "lbl.ERROR_PROCESSING_REQUEST",
            "There was an error processing your request"
          )
        );
      }
      setButtonsState("active");
    };
  };

  const getButtons = (setError, values, submitForm) => {
    let components = [];
    workflowData.forEach((answer) => {
      let { icon, color } = getIconAndColor(answer.ACTION_CODE);
      components.push(
        <UIComponent
          id={answer.WORKFLOW_ACTION}
          name={answer.WORKFLOW_ACTION}
          key={answer.WORKFLOW_RULE_ID}
          className={`${color} btn__no-border save-btn-active`}
          component="smart-button"
          title={t(`btn.${answer.ACTION_CODE}`, answer.ACTION_CODE)}
          iconComponent={<FontAwesomeIcon icon={icon} size={"1x"} />}
          onClick={(event) => {
            const { ACTION_CODE, ENABLE_COMMENT, WORKFLOW_RULE_ID } = answer;
            if (ENABLE_COMMENT) {
              onClickHandler({
                hasComment: true,
                selectedWorkflowRuleId: WORKFLOW_RULE_ID,
                selectedActionCode: ACTION_CODE,
              });
              setButtonsState("active");
            } else {
              onClickHandler({
                hasComment: false,
                selectedWorkflowRuleId: WORKFLOW_RULE_ID,
                selectedActionCode: ACTION_CODE,
              });
              submitForm(
                {
                  action:
                    config.apiAppUrl +
                    evaluationsConfig.APIs.executeEvaluationWorkflow +
                    "/" +
                    answer.WORKFLOW_RULE_ID,
                  method: "POST",
                },
                _submitEvaluationFormCallback({setError, values , actionCode:ACTION_CODE})
              );
            }
          }}
          triggeredText={t("lbl.PROCESSING", "Processing...")}
        >
          {" "}
          {t(`btn.${answer.ACTION_CODE}`, answer.ACTION_CODE)}
        </UIComponent>
      );
    });
    if (actionList.includes(",SAVE,")) {
      components.push(
        <UIComponent
          id="saveForm"
          name="saveForm"
          key="saveForm"
          className="color-blue btn__no-border save-btn-active"
          component="smart-button"
          title={t("lbl.SAVE", "Save")}
          iconComponent={<FontAwesomeIcon icon={faSave} size={"1x"} />}
          onClick={(event) => {           
            submitForm(
              {
                action:
                  config.apiAppUrl + evaluationsConfig.APIs.saveEvaluation,
                method: "POST",
              },
              _saveEvaluationFormCallBack
            );
          }}
          triggeredText={t("lbl.SAVING", "Saving...")}
        >
          {" "}
          {t("lbl.SAVE", "Save")}{" "}
          {formDetails.STATUS_CODE == "DRAFT"
            ? t("lbl.AS_DRAFT", "as Draft")
            : ""}
        </UIComponent>
      );
    }

    if (actionList.includes(",SUBMIT_ON_BEHALF,")) {
      components.push(
        <UIComponent
          id="submitOnBehalf"
          name="submitOnBehalf "
          key="submitOnBehalf"
          className="color-green btn__no-border submit-btn-active"
          component="smart-button"
          title={t("lbl.SUBMIT", "Submit")}
          iconComponent={<FontAwesomeIcon icon={faCheck} size={"1x"} />}
          modal={{
            TITLE: t("lbl.SUBMIT_AS_EVALUATOR", "Submit as Evaluator"),
            BODY: submitOnBehalfBodyTemplate,
            BUTTONS: [
              {
                CLASS: "bg-green color-white btn__no-border",
                ON_CLICK: (event) => {
                  event.preventDefault();                
                  submitForm(
                    {
                      action:
                        config.apiAppUrl +
                        evaluationsConfig.APIs.submitEvaluation,
                      method: "POST",                    
                    },
                    _submitEvaluationFormCallback({setError, values})
                  );
                },                
              },
              {
                CLASS: "bg-blue color-white btn__no-border",
              }
            ],
          }}
          showModal={true}
          triggeredText={t("lbl.SUBMITTING", "Submitting...")}
        >
          {" "}
          {t("lbl.SUBMIT_AS_EVALUATOR", "Submit as Evaluator")}
        </UIComponent>
      );
    }

    if (actionList.includes(",SEND,")) {
      components.push(
        <UIComponent
          id="sendForm"
          name="sendForm "
          key="sendForm"
          className="color-green btn__no-border submit-btn-active"
          component="smart-button"
          title={t("lbl.SEND", "Send")}
          iconComponent={<FontAwesomeIcon icon={faPaperPlane} size={"1x"} />}
          modal={{
            TITLE: t("lbl.SEND_EVALUATION", "Send Evaluation"),
            BUTTONS: [
              {
                CLASS: "bg-green color-white btn__no-border",
                LABEL: t("lbl.YES", "Yes"),
                ON_CLICK: (event) => {
                  event.preventDefault();
                  submitForm(
                    {
                      action:
                        config.apiAppUrl +
                        evaluationsConfig.APIs.sendEvaluation,
                      method: "POST",
                    },
                    _submitEvaluationFormCallback({setError, values})
                  );
                },
              },
              {
                CLASS: "bg-blue color-white btn__no-border",
                LABEL: t("lbl.NO", "No"),
              }
            ],
          }}
          showModal={true}
          triggeredText={t("lbl.SENDING", "Sending...")}
        >
          {" "}
          {t("lbl.SEND_TO_EVALUATOR", "Send to Evaluator")}
        </UIComponent>
      );
    }
    if (actionList.includes(",SUBMIT,")) {
      components.push(
        <UIComponent
          id="submitForm"
          name="submitForm "
          key="submitForm"
          className="color-green btn__no-border submit-btn-active"
          component="smart-button"
          title={t("lbl.SUBMIT", "Submit")}
          iconComponent={<FontAwesomeIcon icon={faCheck} size={"1x"} />}
          modal={{
            TITLE: t("lbl.SUBMIT_EVALUATION", "Submit Evaluation"),
            BODY: submitBodyTemplate,
            BUTTONS: [
              {
                CLASS: "bg-green color-white btn__no-border",
                LABEL: submitYesLabel,
                ON_CLICK: (event) => {
                  event.preventDefault();
                  submitForm(
                    {
                      action:
                        config.apiAppUrl +
                        evaluationsConfig.APIs.submitEvaluation,
                      method: "POST",
                    },
                    _submitEvaluationFormCallback({setError, values})
                  );
                },
              },
              {
                CLASS: "bg-blue color-white btn__no-border",
                LABEL: submitNoLabel,
              }
            ],
          }}
          showModal={true}
          triggeredText={t("lbl.SUBMITTING", "Submitting...")}
        >
          {" "}
          {t("lbl.SUBMIT", "Submit")}{" "}
        </UIComponent>
      );
    }
    if (actionList.includes(",DELETE,")) {
      components.push(
        <UIComponent
          id="deleteForm"
          name="deleteForm "
          key="deleteForm"
          className="color-red-light btn__no-border delete-btn-active"
          component="smart-button"
          title={t("lbl.DELETE", "Delete")}
          iconComponent={<FontAwesomeIcon icon={faTrash} size={"1x"} />}
          modal={{
            TITLE: t("lbl.DELETE_EVALUATION", "Delete Evaluation"),
            BODY: `<p style="text-align:center;margin-bottom:-20px;">${t("lbl.ARE_YOU_SURE_CONFIRMATION", "Are you sure?")}</p>`,
            BUTTONS: [
              { 
                CLASS: "bg-red-light color-white btn__no-border",
                LABEL: t("lbl.CONFIRM", "Confirm"),
                ON_CLICK: (event) => {
                  event.preventDefault();
                  submitForm(
                    {
                      action:
                        config.apiAppUrl +
                        evaluationsConfig.APIs.deleteEvaluation,
                      method: "POST",
                      values: {
                        EVALUATION_ID: formDetails.EVALUATION_ID,
                        USER_FORM_ID: formDetails.USER_FORM_ID,
                      },
                    },
                    _deleteEvaluationFormCallback
                  );
                },
              },
              {
                CLASS: "bg-blue color-white btn__no-border",
                LABEL: t("lbl.CANCEL", "Cancel"),
              }
            ],
          }}
          showModal={true}
          triggeredText={t("lbl.DELETING", "Deleting...")}
        >
          {" "}
          {t("lbl.DELETE", "Delete")}{" "}
        </UIComponent>
      );
    }

    return components;
  };
  return (
    <UIComponent component="smart-form-consumer">
      {({ setError, values, submitForm }) => (
        <UIComponent
          component="button-group"
          id="form-buttons"
          class={`btn-group ${
            formDetails.STATUS_CODE == "DRAFT" ? "btn-group--draft" : ""
          }`}
          getPublicData={(data) => {
            setButtonsState = data.setButtonGroupState;
          }}
          displayType="dropdown"
          dropUp
          compact={compact}
          groupClass="bg-blue color-white btn__no-border"
        >
          {getButtons(setError, values, submitForm)}
        </UIComponent>
      )}
    </UIComponent>
  );
};

export default withRouter(EvaluationButtons);
